import React from 'react';
import Reveal from '../components/Reveal';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-transparent text-on-surface">
      <div className="max-w-container-max mx-auto">
        <Reveal>
          <div className="mb-16">
            <h1 className="font-display-lg text-display-lg text-on-surface mb-6">
              PRIVACY <span className="text-secondary font-medium">POLICY</span>
            </h1>
            <div className="w-12 h-px bg-secondary mb-8"></div>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="glass-panel p-8 md:p-12 prose prose-invert max-w-none">
            <h2 className="text-secondary mb-4">1. Information We Collect</h2>
            <p className="text-on-surface-variant mb-6">
              At HBB0011 Realty, we collect information that you provide directly to us, such as when you request information, subscribe to our newsletter, or contact us. This may include your name, email address, phone number, and any other details you choose to provide.
            </p>

            <h2 className="text-secondary mb-4">2. How We Use Your Information</h2>
            <p className="text-on-surface-variant mb-6">
              The information we collect is used to respond to your inquiries, provide you with the services you requested, and send you relevant updates and marketing communications about our real estate projects.
            </p>

            <h2 className="text-secondary mb-4">3. Information Sharing</h2>
            <p className="text-on-surface-variant mb-6">
              We do not sell or rent your personal information to third parties. We may share your information with trusted partners and service providers who assist us in operating our website and conducting our business, as long as they agree to keep this information confidential.
            </p>

            <h2 className="text-secondary mb-4">4. Security</h2>
            <p className="text-on-surface-variant mb-6">
              We implement reasonable security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no data transmission over the internet can be guaranteed as 100% secure.
            </p>

            <h2 className="text-secondary mb-4">5. Contact Us</h2>
            <p className="text-on-surface-variant mb-6">
              If you have any questions about this Privacy Policy, please contact us at info@hbb0011realty.com.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
